<template>
  <section id="services" class="services-wrapper py-5">
    <div class="container">
      <div class="text-center mb-5">
        <h2 class="display-5 fw-bold mb-3">Servicios</h2>
        <p class="lead services-subtitle">
          Ofrezco desarrollo con stacks modernos, entregando soluciones rápidas,
          confiables y fáciles de mantener.
        </p>
      </div>

      <div class="row justify-content-center g-4 position-relative">
        <div class="decor-dots decor-left d-none d-lg-block" aria-hidden="true"></div>
        <div class="decor-dots decor-right d-none d-lg-block" aria-hidden="true"></div>

        <div class="col-12 col-md-6 col-lg-5">
          <article class="svc-card h-100">
            <div class="svc-icon">
              <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="16" rx="2"></rect>
                <path d="M3 8h18M10 12l-2 2 2 2M14 16l2-2-2-2"></path>
              </svg>
            </div>
            <h3 class="svc-title">Web Development</h3>
            <p class="svc-text">
              SPA/SSR con Vue 3, APIs REST, rutas protegidas, autenticación y despliegues listos para producción.
            </p>
          </article>
        </div>
        
        <div class="col-12 col-md-6 col-lg-5">
          <article class="svc-card h-100">
            <div class="svc-icon">
              <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="4" width="14" height="14" rx="2"></rect>
                <rect x="18" y="8" width="4" height="8" rx="1"></rect>
                <path d="M6 20h6"></path>
              </svg>
            </div>
            <h3 class="svc-title">Responsive Design</h3>
            <p class="svc-text">
              Interfaces limpias y accesibles que se adaptan a móvil, tablet y desktop con performance óptimo.
            </p>
          </article>
        </div>

        <div class="col-12 col-md-6 col-lg-5 mt-md-4">
          <article class="svc-card h-100">
            <div class="svc-icon">
              <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="6" rx="2"></rect>
                <rect x="3" y="14" width="18" height="6" rx="2"></rect>
                <circle cx="8" cy="7" r="1"></circle>
                <circle cx="8" cy="17" r="1"></circle>
              </svg>
            </div>
            <h3 class="svc-title">Backend Development</h3>
            <p class="svc-text">
              APIs en Go y Node, PostgreSQL, migraciones, testing, logging y seguridad (JWT/roles).
            </p>
          </article>
        </div>

        <div class="col-12 col-md-6 col-lg-5 mt-md-4">
          <article class="svc-card h-100">
            <div class="svc-icon">
              <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 3v18h18"></path>
                <path d="M7 15l4-6 3 4 4-8"></path>
              </svg>
            </div>
            <h3 class="svc-title">ERP Services</h3>
            <p class="svc-text">
              Módulos de créditos, reportes y dashboards financieros; integraciones (Odoo, n8n, WhatsApp bot).
            </p>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: "ServicesApp" };
</script>

<style scoped>
/* Wrapper */
.services-wrapper {
  background: #f7f9fc; /* Tu color original */
  /* padding-inline: 200px; <--- ELIMINADO: Esto rompía el responsive */
  width: 100%;
  overflow-x: hidden; /* Evita scroll lateral por los puntos decorativos */
}

/* Subtitle */
.services-subtitle {
  max-width: 720px;
  margin: 0 auto;
  color: #c3c3c3; /* Tu color original */
}

/* Card */
.svc-card {
  background: #ffffff40; /* Tu color original */
  border-radius: 14px;
  padding: 22px 22px;
  box-shadow: 0 2px 10px rgba(16, 24, 40, 0.04),
    0 8px 30px rgba(16, 24, 40, 0.06);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
  
  /* Opcional: añade backdrop-filter para que se vea mejor el efecto transparente */
  backdrop-filter: blur(5px); 
}

.svc-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.06),
    0 18px 42px rgba(16, 24, 40, 0.08);
}

.svc-icon {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  background: #eef4ff; /* Tu color original */
  color: #3b82f6; /* Tu color original */
  margin-bottom: 12px;
}

.svc-title {
  font-size: 1.05rem;
  font-weight: 700;
  margin: 4px 0 6px;
  color: #ffffff; /* Tu color original (Ojo: Blanco sobre fondo claro puede no verse bien) */
  letter-spacing: 0.2px;
}

.svc-text {
  margin: 0;
  color: #ebebf1; /* Tu color original */
  font-size: 0.95rem;
  line-height: 1.45rem;
}

/* Decorative dotted blocks */
.decor-dots {
  position: absolute;
  width: 120px;
  height: 120px;
  background-image: radial-gradient(#e5e9fc 1.5px, transparent 1.5px);
  background-size: 14px 14px;
  opacity: 0.55;
  filter: saturate(1.1);
  z-index: 0;
}

.decor-left {
  left: -20px;
  top: 40%;
  transform: translateY(-50%);
}

.decor-right {
  right: -20px;
  top: 65%;
  transform: translateY(-50%);
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .svc-card {
    padding: 18px;
  }
  .services-subtitle {
    font-size: 0.98rem;
  }
}
</style>